import { defineMessages } from 'react-intl';

export default defineMessages({
    home: {
        id: 'ml.gateway.views.new-quote.Home',
        defaultMessage: 'HOME',
    },
    helpChat: {
        id: 'ml.gateway.views.ask-so.helpchat',
        defaultMessage: 'HELP/CHAT',
    },
    startNewQuote: {
        id: 'ml.gateway.views.new-quote.Start A New Quote',
        defaultMessage: 'NEW QUOTE',
    },
    searchPlaceHolder: {
        id: 'gateway.views.search-quote.Search by account or policy number.',
        defaultMessage: 'Search by account or policy number...',
    },
    login: {
        id: 'auth.components.AuthStatus.Login',
        defaultMessage: 'Login',
    },
    account: {
        id: 'auth.components.AuthStatus.Account',
        defaultMessage: 'Account',
    },
    preferences: {
        id: 'auth.components.AuthStatus.Preferences',
        defaultMessage: 'Preferences',
    },
    logOut: {
        id: 'auth.components.AuthStatus.Log out',
        defaultMessage: 'Logout',
    },
    vueLink: {
        id: 'auth.components.AuthStatus.VueLink',
        defaultMessage: 'Producer & Compensation Management'
    },
    quoteAnyAccount: {
        id: 'gateway.views.new-quote.Quote for Any Account',
        defaultMessage: 'Quote for Any Account'
    },
    quoteThisAccount: {
        id: 'gateway.views.new-quote.Quote for This Account',
        defaultMessage: 'Quote for This Account'
    },
    preferencesLink: {
        id: 'gateway.views.new-quote.Preferences',
        defaultMessage: 'Preferences'
    }
});